<div class="table-card">
  <div class="card-header">
    <div class="card-header-icon table-icon">
      <i class="pi pi-users"></i>
    </div>
    <span class="card-header-title">{{ 'contador.aprovacao.titulo' | translate }}</span>
    <div class="card-header-actions">
      <p-iconField iconPosition="right" class="busca-solicitacoes">
        <p-inputIcon styleClass="pi pi-search" />
        <input pInputText type="text"
          [placeholder]="'contador.aprovacao.busca_placeholder' | translate"
          [ngModel]="termoBusca"
          (ngModelChange)="onBuscaChange($event)" />
      </p-iconField>
      <p-dropdown
        [options]="statusOptions"
        [(ngModel)]="statusAtual"
        optionLabel="label"
        optionValue="value"
        [placeholder]="'contador.aprovacao.filtro_status' | translate"
        (onChange)="onStatusChange()">
      </p-dropdown>
    </div>
  </div>

  <div class="card-content">
    <p-table [value]="solicitacoes"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [loading]="loading"
      [tableStyle]="{ width: '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 16%">{{ 'contador.aprovacao.col_solicitante' | translate }}</th>
          <th style="width: 20%">{{ 'contador.aprovacao.col_email' | translate }}</th>
          <th style="width: 12%" pSortableColumn="solicitadoEm">
            {{ 'contador.aprovacao.col_data' | translate }}<p-sortIcon [field]="'solicitadoEm'"></p-sortIcon>
          </th>
          <th style="width: 10%" pSortableColumn="status">
            {{ 'contador.aprovacao.col_status' | translate }}<p-sortIcon [field]="'status'"></p-sortIcon>
          </th>
          <th style="width: 15%">{{ 'contador.aprovacao.col_motivo' | translate }}</th>
          <th style="width: 15%">{{ 'contador.aprovacao.col_motivo_decisao' | translate }}</th>
          <th style="width: 12%">{{ 'contador.aprovacao.col_acoes' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-solicitacao>
        <tr>
          <td>{{ solicitacao.nomeSolicitante || '-' }}</td>
          <td>{{ solicitacao.emailSolicitante || '-' }}</td>
          <td>{{ formatarData(solicitacao.solicitadoEm) }}</td>
          <td>
            <p-tag
              [value]="labelStatus(solicitacao.status)"
              [severity]="severityStatus(solicitacao.status)">
            </p-tag>
          </td>
          <td>
            <span *ngIf="solicitacao.observacao; else semMotivo"
                  class="motivo-cell"
                  [pTooltip]="solicitacao.observacao"
                  tooltipPosition="top"
                  [attr.aria-label]="solicitacao.observacao">
              {{ solicitacao.observacao }}
            </span>
            <ng-template #semMotivo>-</ng-template>
          </td>
          <td>
            <span *ngIf="solicitacao.motivoDecisao; else semMotivoDecisao"
                  class="motivo-cell"
                  [pTooltip]="solicitacao.motivoDecisao"
                  tooltipPosition="top"
                  [attr.aria-label]="solicitacao.motivoDecisao">
              {{ solicitacao.motivoDecisao }}
            </span>
            <ng-template #semMotivoDecisao>-</ng-template>
          </td>
          <td class="actions">
            <ng-container *ngIf="podeDecidir(solicitacao); else semAcao">
              <button pButton
                [label]="'contador.aprovacao.botao_aprovar' | translate"
                icon="pi pi-check"
                class="btn-primary btn-sm"
                [disabled]="processando"
                (click)="abrirDialogAprovar(solicitacao)">
              </button>
              <button pButton
                [label]="'contador.aprovacao.botao_recusar' | translate"
                icon="pi pi-times"
                severity="danger"
                class="btn-sm ml-2"
                [disabled]="processando"
                (click)="abrirDialogRecusar(solicitacao)">
              </button>
            </ng-container>
            <ng-template #semAcao>
              <span class="sem-acao">-</span>
            </ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center p-5">
            <div class="flex flex-column align-items-center">
              <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
              <div class="text-gray-500 text-lg">{{ 'contador.aprovacao.vazio' | translate }}</div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td colspan="7" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
              <span class="ml-3">{{ 'contador.aprovacao.carregando' | translate }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao (mesmo modelo da aba "Repasse de Comissoes"):
         contagem a esquerda, "Itens por pagina" + dropdown a direita.
         Tabela lazy: a troca de pagina dispara onPageChange, que recarrega
         do backend. -->
    <div class="pagination-container">
      <div>
        <p-paginator
          (onPageChange)="onPageChange($any($event))"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="'contador.aprovacao.contagem' | translate"
          [first]="first" [rows]="rows"
          [totalRecords]="totalRecords" [showFirstLastIcon]="true">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ 'contador.aprovacao.itens_por_pagina' | translate }}</span>
        <!-- appendTo="body": o painel seria recortado pelo overflow do card;
             renderizado no body fica imune (igual aos demais dropdowns). -->
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [(ngModel)]="rows"
          (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem"
          appendTo="body">
        </p-dropdown>
      </div>
    </div>
  </div>
</div>

<!-- =================================================================== -->
<!-- Dialog: Confirmar aprovacao (wave header --info)                    -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="aprovarDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '34rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="fecharDialogAprovar()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-check" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.aprovacao.dialog_aprovar_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle" *ngIf="solicitacaoSelecionada">
          {{ solicitacaoSelecionada.nomeSolicitante || solicitacaoSelecionada.emailSolicitante }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador.aprovacao.confirmar_aprovar' | translate }}</p>

    <!-- Plano (OBRIGATORIO): o backend cria a inscricao do contador nele -->
    <div class="field mt-3">
      <label class="block mb-2 font-medium">
        {{ 'contador.aprovacao.plano_especial_label' | translate }}
        <span class="obrigatorio">*</span>
      </label>

      <!-- Carregando planos -->
      <div *ngIf="carregandoPlanos" class="text-color-secondary">
        <i class="pi pi-spinner pi-spin mr-2"></i>{{ 'contador.aprovacao.plano_especial_carregando' | translate }}
      </div>

      <!-- Nenhum plano cadastrado: aviso bloqueante -->
      <div *ngIf="semPlanos" class="plano-especial-vazio">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ 'contador.aprovacao.plano_vazio' | translate }}</span>
      </div>

      <!-- Ha planos, mas nenhum especial: aviso INFORMATIVO (nao bloqueia) -->
      <div *ngIf="apenasPlanosComuns" class="plano-especial-info">
        <i class="pi pi-info-circle"></i>
        <span>{{ 'contador.aprovacao.plano_sem_especial_info' | translate }}</span>
      </div>

      <!-- Seletor de plano: lista TODOS os planos ativos; qualquer um selecionavel -->
      <p-dropdown *ngIf="!carregandoPlanos && !erroPlanos && planosOptions.length > 0"
        [options]="planosOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="planoSelecionado"
        appendTo="body"
        styleClass="w-full"
        panelStyleClass="plano-especial-dropdown-panel dropdown-panel-above-modal"
        [placeholder]="'contador.aprovacao.plano_especial_placeholder' | translate">
        <!-- Valor selecionado: apenas o nome (sem a descricao). -->
        <ng-template let-opt pTemplate="selectedItem">
          <span class="plano-opcao-nome">{{ opt?.label }}</span>
        </ng-template>
        <!-- Item do painel: nome + descricao; comum tambem mostra periodicidade e valor. -->
        <ng-template let-opt pTemplate="item">
          <div class="plano-opcao">
            <span class="plano-opcao-nome">
              {{ opt.label }}
              <span *ngIf="opt.especial" class="plano-opcao-tag">
                {{ 'contador.aprovacao.plano_especial_badge' | translate }}
              </span>
            </span>
            <small *ngIf="opt.descricao" class="plano-opcao-desc">{{ opt.descricao }}</small>
            <small *ngIf="!opt.especial" class="plano-opcao-meta">
              {{ periodicidadeLabel(opt.tipoPlano) }} &middot; {{ formatarValorPlano(opt.valor) }}
            </small>
            <!-- Base de usuarios do plano: o TOTAL informado abaixo soma sobre ela -->
            <small class="plano-opcao-meta">
              {{ 'contador.aprovacao.plano_usuarios_inclusos' | translate:{ quantidade: opt.usuariosInclusos ?? 1 } }}
            </small>
          </div>
        </ng-template>
      </p-dropdown>

      <small class="block mt-2 text-color-secondary">{{ 'contador.aprovacao.plano_especial_ajuda' | translate }}</small>
    </div>

    <!-- Usuarios de acesso do contador (TOTAL, nao incremento) -->
    <div class="field mt-3">
      <label class="block mb-2 font-medium">
        {{ 'contador.aprovacao.usuarios_label' | translate }}
        <span class="obrigatorio">*</span>
      </label>
      <p-inputNumber
        [(ngModel)]="usuariosPermitidos"
        mode="decimal"
        [min]="usuariosMinimo"
        [max]="usuariosMaximo"
        [maxFractionDigits]="0"
        [useGrouping]="false"
        [placeholder]="'contador.aprovacao.usuarios_placeholder' | translate"
        styleClass="w-full"
        inputStyleClass="w-full">
      </p-inputNumber>
      <small class="block mt-2 text-color-secondary">{{ 'contador.aprovacao.usuarios_ajuda' | translate:{ min: usuariosMinimo, max: usuariosMaximo } }}</small>
    </div>

    <div class="field mt-3">
      <label class="block mb-2 font-medium">{{ 'contador.aprovacao.percentuais_label' | translate }}</label>
      <p-selectButton
        [options]="percentuaisOpcoes"
        optionLabel="label"
        optionValue="value"
        [multiple]="true"
        [(ngModel)]="percentuaisSelecionados">
      </p-selectButton>
      <small class="block mt-2 text-color-secondary">{{ 'contador.aprovacao.percentuais_ajuda' | translate }}</small>
    </div>

    <!-- Comissao (%) por percentual selecionado -->
    <div class="field mt-3" *ngIf="percentuaisSelecionados.length > 0">
      <label class="block mb-2 font-medium">{{ 'contador.aprovacao.comissao_titulo' | translate }}</label>
      <div class="comissoes-lista">
        <div class="comissao-item flex align-items-center mb-2" *ngFor="let p of percentuaisSelecionados">
          <span class="comissao-percentual mr-3 font-medium">{{ p }}%</span>
          <p-inputNumber
            [(ngModel)]="comissoesPorPercentual[p]"
            mode="decimal"
            suffix="%"
            [min]="0"
            [max]="100"
            [placeholder]="'contador.aprovacao.comissao_label' | translate"
            styleClass="w-full"
            inputStyleClass="w-full">
          </p-inputNumber>
        </div>
      </div>
      <small class="block mt-2 text-color-secondary">{{ 'contador.aprovacao.comissao_ajuda' | translate }}</small>
    </div>

    <!-- Motivo da aprovacao (opcional) -->
    <div class="field mt-3">
      <label class="block mb-2 font-medium">{{ 'contador.aprovacao.motivo_aprovacao_label' | translate }}</label>
      <textarea pInputTextarea
        [(ngModel)]="motivoAprovacao"
        [rows]="2"
        maxlength="500"
        class="w-full"
        [placeholder]="'contador.aprovacao.motivo_aprovacao_placeholder' | translate">
      </textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador.aprovacao.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="processando"
      (click)="fecharDialogAprovar()">
    </button>
    <button pButton
      [label]="'contador.aprovacao.confirmar' | translate"
      icon="pi pi-check"
      class="btn-primary"
      style="gap: 0.35rem"
      [disabled]="processando || carregandoPlanos || semPlanos"
      [loading]="processando"
      (click)="confirmarAprovar()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: Recusar solicitacao (wave header --danger)                  -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="recusarDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '34rem' }"
  (onHide)="fecharDialogRecusar()">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-times" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.aprovacao.dialog_recusar_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle" *ngIf="solicitacaoSelecionada">
          {{ solicitacaoSelecionada.nomeSolicitante || solicitacaoSelecionada.emailSolicitante }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador.aprovacao.confirmar_recusar' | translate }}</p>

    <div class="form-field full">
      <label class="form-label">{{ 'contador.aprovacao.observacao_recusa_label' | translate }}</label>
      <textarea pInputTextarea
        class="w-full"
        [(ngModel)]="motivoRecusa"
        [rows]="3"
        maxlength="500"
        [placeholder]="'contador.aprovacao.observacao_recusa_placeholder' | translate"
        [disabled]="processando">
      </textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador.aprovacao.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="processando"
      (click)="fecharDialogRecusar()">
    </button>
    <button pButton
      [label]="'contador.aprovacao.botao_recusar' | translate"
      icon="pi pi-times"
      severity="danger"
      style="gap: 0.35rem"
      [disabled]="processando"
      [loading]="processando"
      (click)="confirmarRecusar()">
    </button>
  </ng-template>
</p-dialog>

<p-toast />
